// src/pages/HomePage.js
import React, { useState, useEffect } from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import GateIcon from "../components/GateIcon";
import OfflineBanner from "../components/OfflineBanner";
import SpeechIcon from "../components/SpeechIcon";

function HomePage() {
  const navigate = useNavigate();

  const [isOffline, setIsOffline] = useState(false);
  const [retryAttempt, setRetryAttempt] = useState(0);

  const [showInfoPopup, setShowInfoPopup] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkConnection = async () => {
      try {
        await fetch("https://www.gstatic.com/firebasejs/9.6.1/firebase-app.js", {
          method: "HEAD",
          cache: "no-store",
        });

        if (mounted) {
          setIsOffline(false);
        }
      } catch (err) {
        console.warn("Keine Server-Verbindung möglich (HomePage):", err);

        if (mounted) {
          setIsOffline(true);
        }
      }
    };

    checkConnection();

    return () => {
      mounted = false;
    };
  }, [retryAttempt]);

  useEffect(() => {
    const hidePopup = localStorage.getItem("hideHomeInfoPopup");
    if (!hidePopup) setShowInfoPopup(true);
  }, []);

  const handleRetry = () => {
    setIsOffline(false);
    setTimeout(() => {
      setRetryAttempt((prev) => prev + 1);
    }, 600);
  };

  const handleClosePopup = () => {
    const checkbox = document.getElementById("hide-home-popup-checkbox");

    if (checkbox && checkbox.checked) {
      localStorage.setItem("hideHomeInfoPopup", "true");
    }

    setShowInfoPopup(false);
  };

  return (
    <div className="HomePage">
      {isOffline && <OfflineBanner onRetry={handleRetry} />}

      {showInfoPopup && (
        <div className="info-popup-overlay">
          <div className="info-popup-container home-info-popup-container">
            <p className="info-popup-text">
              <strong>Willkommen bei Edens Ernte!</strong>
              <br />
              <br />
              Schön, dass du da bist. Edens Ernte ist eine noch junge Plattform,
              die Schritt für Schritt mit ihrer Community wächst.
              <br />
              <br />
              Tausche dich im <strong>Forum</strong> aus und entdecke tolle{" "}
              <strong>Rezeptideen</strong> mit unserem <strong>Küchenhelfer</strong> – beides findest du oben rechts!
              <br />
              <br />
              Damit wir die Nutzererfahrung weiter verbessern können, freuen
              wir uns über Feedback, Anregungen und Hinweise zu möglichen
              Fehlern. Unser Kontaktformular findest du jederzeit unten im
              Footer.
              <br />
              <br />
              Viel Spaß beim Entdecken, Tauschen, Teilen und gemeinsamen
              Wachsen!
               </p>

            <div className="info-popup-actions">
              <label className="info-popup-checkbox">
                <input type="checkbox" id="hide-home-popup-checkbox" />
                Diese Nachricht nicht mehr anzeigen
              </label>

              <button className="info-popup-button" onClick={handleClosePopup}>
                Verstanden
              </button>
            </div>
          </div>
        </div>
      )}

      <GateIcon className="login-icon" />
      <SpeechIcon className="speech-icon no-tap-highlight" />

      <img
        src="/rezept-icon.png"
        alt="Rezepthelfer Icon"
        className="rezept-icon"
        onClick={() => navigate("/rezepte")}
      />

      <div className="content">
        <div className="logo-wrapper">
          <img
            src="/logo-edens-ernte-transparent.png"
            alt="Logo"
            className="homepage-logo"
          />
        </div>

        <p className="home-description">
          Willkommen bei Edens Ernte – der Tauschbörse für Obst,
          Gemüse und Pflanzen aus deiner Region!
        </p>

        <button
          className="start-button"
          onClick={() => navigate("/browse")}
        >
          An die Erde, fertig, teilen!
        </button>
      </div>
    </div>
  );
}

export default HomePage;